<template>
    <div class="theme-ui-text-color mute cursor-pointer absolute" @click="handleMute">
        <i v-if="muted" class="theme-question-shadow fas fa-volume-mute"></i>
        <i v-if="!muted" class="theme-question-shadow fas fa-volume-up"></i>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'bg-music-mute-btn',

    props: {
        isMuted: {
            type: Boolean
        },

        isSpotify: {
            type: Boolean
        }
    },

    computed: {
        ...mapGetters({
            audioSpotify: 'getSpotifyAudio'
        })
    },

    watch: {
        muted(muted) {
            if (this.audioSpotify) {
                this.audioSpotify.muted = muted
            }
        }
    },

    data() {
        return {
            muted: false
        }
    },

    mounted() {
        this.muted = this.isMuted
    },

    methods: {
        handleMute() {
            this.muted = !this.muted
            this.$store.commit('updateIsMuted', this.muted)
        },

        onSponsorVideo() {
            this.muted = true
        }
    }
}
</script>

<style lang="scss" scoped>
.mute {
    top: 0;
    right: 0;
    font-size: 20px;
    width: 31.67px;
    height: 31.67px;
    display: flex;
    align-items: center;
}
</style>
